import React, { useEffect, useState, useMemo } from "react";
import { getFoodItems } from "../api/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import FoodCard from "../components/FoodCard/FoodCard";
import FadeUp from "../components/UI/FadeUp";
import SearchResults from "./SearchResults";
import CategorySlider from "../components/CategorySlider/CategorySlider";
import "../styles/Menu.css";

const Menu = () => {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearchParams] = useSearchParams();
  const initialCategory = search.get("category") && search.get("category") !== "All" ? search.get("category") : "";
  const [searchTerm, setSearchTerm] = useState(initialCategory);
  const navigate = useNavigate();

  useEffect(() => {
    getFoodItems()
      .then(res => {
        const payload = res.data;
        const list = Array.isArray(payload) ? payload : Array.isArray(payload.foodItems) ? payload.foodItems : [];
        setMenu(list);
      })
      .catch(err => {
        console.error(err);
        setError("Error fetching menu");
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const cat = search.get("category");
    if (cat) {
      setSearchTerm(cat === "All" ? "" : cat);
    }
  }, [search]);

  const filteredMenu = useMemo(() => {
    if (!Array.isArray(menu)) return [];
    return menu.filter((item) => {
      const t = searchTerm.toLowerCase();
      return item.name.toLowerCase().includes(t) || (item.description && item.description.toLowerCase().includes(t));
    });
  }, [menu, searchTerm]);

  const handleCategorySelect = (categoryName) => {
    setSearchParams({ category: categoryName });
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '120px 24px 64px' }}>
      <FadeUp>
        <h2 style={{ fontSize: '32px', color: 'var(--text-dark)', marginBottom: '16px', textAlign: 'center' }}>Our Menu</h2>
      </FadeUp>

      <CategorySlider onSelectCategory={handleCategorySelect} />

      <FadeUp delay={0.1}>
        <div style={{ maxWidth: '600px', margin: '0 auto 48px' }}>
          <input
            type="text"
            className="search-input"
            style={{ width: '100%', padding: '16px 24px', borderRadius: '50px', border: '1px solid #E5E7EB', boxShadow: 'var(--shadow-sm)' }}
            placeholder="Search dishes by name or description…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </FadeUp>

      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

      {searchTerm ? (
        <SearchResults
          items={filteredMenu}
          onSelect={(item) => {
            setSearchTerm("");
            const id = item.id || item.food_id;
            navigate(`/menu/${id}`);
          }}
          placeholder="dishes"
        />
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '24px' }}>
          {loading ? (
            Array.from({ length: 8 }).map((_, idx) => (
              <div key={idx} style={{ background: 'white', padding: '16px', borderRadius: '16px', border: '1px solid #F3F4F6' }}>
                <Skeleton height={180} style={{ borderRadius: '20px', marginBottom: '16px' }} />
                <Skeleton width="60%" height={20} />
                <Skeleton width="100%" height={16} count={2} style={{ marginTop: '8px' }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
                  <Skeleton width={60} height={24} />
                  <Skeleton width={80} height={36} style={{ borderRadius: '12px' }} />
                </div>
              </div>
            ))
          ) : (
            filteredMenu.map((item, idx) => (
              <FadeUp key={item.id || item.food_id} delay={idx * 0.05}>
                <FoodCard item={item} />
              </FadeUp>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default Menu;
